'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BufferSettings = require('@/components/BufferSettings.vue');

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BufferSettings2.default]
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/BufferSettings.vue
// module id = 5905
// module chunks = 1